import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

const container = document.getElementById("root");
const application = <React.StrictMode><ErrorBoundary><App /></ErrorBoundary></React.StrictMode>;
if (container.dataset.publicPrerender === 'true') ReactDOM.hydrateRoot(container, application);
else ReactDOM.createRoot(container).render(application);

// Loaded only by the offline, unauthenticated public-page build runner.
if (window.__INSIGHT_PRERENDER_BUILD__ === true) {
  import('./public/prerender').then(({renderPublic}) => { window.__renderInsightPublic = renderPublic; });
}
